import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface EmailProvisioningConfirmationDialogProps {
  open: boolean
  processing: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export default function EmailProvisioningConfirmationDialog({
  open,
  processing,
  onOpenChange,
  onConfirm,
}: EmailProvisioningConfirmationDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Provisionar email do colaborador?</AlertDialogTitle>
          <AlertDialogDescription>
            A opção "Não provisionar email" está desligada. Ao continuar, o sistema vai provisionar um email StationZero para este colaborador digital.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button" disabled={processing}>Voltar</AlertDialogCancel>
          <AlertDialogAction type="button" onClick={onConfirm} disabled={processing}>
            Provisionar email e continuar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
